import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    console.log(nextPage);
    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'om-brillerne';
            break;
        case 'om-brillerne':
            nextPage = 'skadebeskrivelse';
            break;
        case 'skadebeskrivelse':
            nextPage = 'skete-skaden-paa-arbejde';
            break;
        case 'skete-skaden-paa-arbejde':
            nextPage = 'bruges-brillerne-paa-arbejde';
            break;
        case 'bruges-brillerne-paa-arbejde':
            if (getValueOrDefault(formConfig, formValues, 'erdertaleombrillerderkunbrugesparbejde').value === 'Yes') {
                nextPage = 'betalt-af-arbejdsgiver';
            } else {
                nextPage = 'pris';
            }
            break;
        case 'betalt-af-arbejdsgiver':
            nextPage = 'pris';
            break;
        case 'pris':
            nextPage = 'optiker';
            break;
        case 'optiker':
            nextPage = 'nye-briller';
            break;
        case 'nye-briller':
            nextPage = 'om-brilleejeren-1';
            break;
        case 'om-brilleejeren-1':
            nextPage = 'om-brilleejeren-2';
            break;
        case 'om-brilleejeren-2':
            if (getValueOrDefault(formConfig, formValues, 'havdebrilleejerenbrillernepdaskadenskete').value === 'Nej') {
                nextPage = 'om-brilleejeren-3';
            } else {
                nextPage = 'om-brilleejeren-4';
            }
            break;
        case 'om-brilleejeren-3':
            nextPage = 'om-brilleejeren-4';
            break;
        case 'om-brilleejeren-4':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'virksomhedsoplysninger';
            break;
        case 'virksomhedsoplysninger':
            nextPage = 'forsikringsmaegler';
            break;

        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
